module.exports = __webpack_public_path__ + "img/pro-m-slider9.d1f0fee5.png";